<template>
  <table class="table">
    <thead>
      <slot name="columns">
        <tr>
          <th v-for="column in columns" :key="column">{{column}}</th>
        </tr>
      </slot>
    </thead>
    <tbody>
    <tr v-for="(item, index) in data" :key="index">
        <slot :row="item">
          <td v-for="column in columns" :key="column">
            <a style="color:black; font-weight: normal;">
              <i v-bind:class="itemIcone(item, column)" v-bind:style="iconeColor(item, column)"></i>
              <span>{{ itemValue(item, column) }}</span>
            </a>
          </td>
      </slot>
    </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'l-table',
    props: {
      columns: Array,
      data: Array
    },
    methods: {
      itemValue (item, column) {
        const retorno = item[column].valor;
        return retorno;
      },
      itemIcone (item, column) {
        // console.log("item", item);
        // console.log("coluna", column);
        // console.log("item.coluna", item[column]);
        const retorno = item[column].icone;
        return retorno;
      },
      iconeColor (item, column) {
        const retorno = item[column].style;
        return retorno;
      }
    }
  }
</script>
<style>
</style>
